import ipfsClient from 'ipfs-http-client';

// connect to ipfs daemon API server using options
const ipfs = ipfsClient({ host: 'ipfs.infura.io', port: '5001', protocol: 'https' })

export default ipfs;
